import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcEnterpriseName = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M18.248 9.428a.5.5 0 0 0-.748.434V19.5a.5.5 0 0 0 .5.5h2a1 1 0 0 0 1-1v-7.42a1 1 0 0 0-.504-.867l-2.248-1.285ZM3.504 10.713A1 1 0 0 0 3 11.58V19a1 1 0 0 0 1 1h2a.5.5 0 0 0 .5-.5V9.861a.5.5 0 0 0-.748-.434l-2.248 1.285Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M8 5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v14.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V18a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V5Zm2 2.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75Zm.75 2.5a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcEnterpriseName");

export { IcEnterpriseName };
//# sourceMappingURL=ic-enterprise-name.js.map
